import { Injectable } from '@angular/core';
import { SortOption } from '../../interfaces/sort-option.interface';

@Injectable()
export class ConfigServiceProvider {
  private readonly api = {
    definition: '/api/dictionary-items/definition',
    dataView: '/api/data-view',
  };

  private currentBackendBaseApi: string;

  public setBackendBaseAPI(backendBaseAPI: string): void {
    backendBaseAPI = backendBaseAPI && backendBaseAPI.trim();
    if (!backendBaseAPI) {
      throw new Error('[ConfigServiceProvider] A provided backendBaseAPI is incorrect');
    }
    this.currentBackendBaseApi = backendBaseAPI;
  }

  public getBackendBaseAPI(): string {
    if (!this.currentBackendBaseApi) {
      throw new Error('[ConfigServiceProvider] A backendBaseAPI has not been set');
    }
    return this.currentBackendBaseApi;
  }

  getUrl(dataViewBaseAPI: string, dataSourceType: string): string {
    if (dataViewBaseAPI && this.api[dataSourceType]) {
      return dataViewBaseAPI + this.api[dataSourceType];
    }
    return null;
  }

  getUrlWithParameter(
    dataViewBaseAPI: string,
    dataSourceType: string,
    resourceIdentifier: string,
    sort: SortOption[],
    searchPhase: string = null,
    filters: string = null,
  ): any {
    const url = this.getUrl(dataViewBaseAPI, dataSourceType);
    let searchQuery = this.getSearchQuery(searchPhase);
    searchQuery = searchQuery.length > 0 ? '?' + searchQuery : searchQuery;
    let filtersParameter = this.getFilters(filters);
    filtersParameter = filtersParameter.length > 0 ? (searchQuery.startsWith('?') ? '&' + filtersParameter : '?' + filtersParameter) : '';
    let sortParameter = this.getSortParameter(sort);
    sortParameter = sortParameter.length > 0 ? ((searchQuery.startsWith('?') || filtersParameter.startsWith('?')) ? '&' + sortParameter : '?' + sortParameter) : '';
    let s = url ? `${url}/${resourceIdentifier}${searchQuery}${filtersParameter}${sortParameter}` : null;
    s = s.indexOf('?') > 0 ? s + '&page=0&size=3000' : s + '?page=0&size=3000';
    return s;
  }

  private getSearchQuery(searchPhase: string): string {
    if (!searchPhase) {
      return '';
    }

    return `searchQuery=${searchPhase.trim().toLocaleLowerCase()}`;
  }

  private getSortParameter(sort: SortOption[]): string {
    if (!sort || sort.length === 0) {
      return '';
    }

    let sortParameter = '';

    sort.forEach((sortOption: SortOption) => {
      sortParameter += sortParameter === '' ? '' : '&';
      sortParameter += `sort=${sortOption.property},${sortOption.direction}`;
    });

    return sortParameter;
  }

  private getFilters(filters: string) {
    if(!filters || filters.length === 0) {
      return '';
    }

    return `filters=${filters}`;
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_forms/projects/forms/src/lib/services/config/config.service.ts